import React from "react";

const countries = [
  "Austria",
  "Belgium",
  "Croatia",
  "Cyprus",
  "Finland",
  "Germany",
  "France",
  "Ireland",
  "Italy",
  "Latvia",
  "Lithuania",
  "Netherlands",
  "Poland",
  "Romania",
  "Slovakia",
  "Spain",
  "Sweden",
  "United Kingdom",
];

const flagSources = {
  Austria: "/flags/austria.png",
  Belgium: "/flags/belgium.png",
  Croatia: "/flags/croatia.png",
  Finland: "/flags/finland.png",
  Germany: "/flags/germany.png",
  France: "/flags/france.png",
  Ireland: "/flags/ireland.png",
  Italy: "/flags/italy.png",
  Lithuania: "/flags/lithuania.png",
  Netherlands: "/flags/netherlands.png",
  Poland: "/flags/poland.png",
  Romania: "/flags/romania.png",
  Slovakia: "/flags/slovakia.png",
  Spain: "/flags/Spain.png",
  Sweden: "/flags/sweden.png",
  Cyprus: "/flags/cyprus.png",
  Latvia: "/flags/latvia.png",
  "United Kingdom": "/flags/unitedkingdom.png",
};

export default function Countries() {
  return (
    <>
      {/* ================= MOBILE ================= */}
      <section className="relative md:hidden bg-white px-10 md:px-16 lg:px-24 xl:px-40 pt-32 pb-[16px] text-black flex flex-col items-center">
        <h2 className="font-inter text-[22px] font-bold leading-tight text-center">
          Countries that have <span className="text-[#1A3274]">mandated </span>
          tethered caps
        </h2>

        <div className="mt-10 grid grid-cols-2 gap-y-8 gap-x-6 w-full max-w-[500px] justify-items-start">
          {countries.map((country) => {
            const src = flagSources[country];
            return (
              <div key={country} className="flex items-center gap-3 w-full">
                <img
                  src={src}
                  alt={`${country} flag`}
                  className="h-9 w-9 rounded-full object-cover flex-shrink-0"
                />
                <span className="font-inter text-[14px] leading-[133%] break-words">
                  {country}
                </span>
              </div>
            );
          })}
        </div>
      </section>

      {/* ================= DESKTOP (UNCHANGED) ================= */}
      <section className="relative hidden md:block min-h-screen bg-white text-black overflow-hidden px-10 md:px-16 lg:px-24 xl:px-40 pt-32 pb-[16px]">
        <h2
          className="
            mx-auto
            max-w-[573px]
            font-inter
            text-[clamp(32px,3.5vw,47.7388px)]
            leading-[1.03]
            font-bold
            text-center
          "
        >
          Countries that have <span className="text-[#1A3274]">mandated </span>
          tethered caps
        </h2>

        <div
          className="
            mt-[92px]
            mx-auto
          "
        >
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 xl:grid-cols-6 gap-y-[clamp(105px,3vw,109.73px)] gap-x-[clamp(20px,3vw,49.73px)] md:max-w-[720px] lg:max-w-none md:justify-items-center lg:justify-items-start">
            {countries.map((country) => {
              const src = flagSources[country];
              return (
                <div key={country} className="flex items-center gap-3">
                  <img
                    src={src}
                    alt={`${country} flag`}
                    className="h-[clamp(35px,3vw,45.83px)] w-[clamp(35px,3vw,45.83px)] rounded-full object-cover flex-shrink-0"
                  />
                  <span className="font-inter font-normal text-[clamp(16px,1.8vw,25.352px)] leading-[133%] text-black">
                    {country}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
